import { useEffect, useState } from 'react';

type Remaining = { days: number; hours: number; minutes: number; seconds: number };

function untilMidnight(): Remaining {
  const now = new Date();
  const end = new Date(now);
  end.setHours(24, 0, 0, 0);
  const diff = Math.max(0, end.getTime() - now.getTime());
  const total = Math.floor(diff / 1000);
  return {
    days: Math.floor(total / 86400),
    hours: Math.floor((total % 86400) / 3600),
    minutes: Math.floor((total % 3600) / 60),
    seconds: total % 60,
  };
}

export function useCountdown(): Remaining {
  const [remaining, setRemaining] = useState<Remaining>(untilMidnight);

  useEffect(() => {
    const id = window.setInterval(() => setRemaining(untilMidnight()), 1000);
    return () => window.clearInterval(id);
  }, []);

  return remaining;
}
